import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule,
  CurrencyPipe,
  DatePipe
} from '@angular/common';

import {
  Router,
  RouterLink
} from '@angular/router';

import {
  ApiService
} from '../../core/api.service';
import { CartService } from '../../core/cart.service';

@Component({
  selector: 'app-customer-orders',
  standalone: true,

  imports: [
    CommonModule,
    CurrencyPipe,
    DatePipe,
    RouterLink
  ],

  templateUrl:
    './customer-orders.component.html',

  styleUrl:
    './customer-orders.component.css'
})
export class CustomerOrdersComponent
  implements OnInit {

  orders: any[] = [];

  loading = true;
  error = '';

  customer: any = this.getStoredCustomer();

  constructor(
    private api: ApiService,
    private router: Router,
     private readonly cart: CartService
  ) {}

  ngOnInit(): void {
    const token =
      localStorage.getItem('customer_token');

    if (!token) {
      this.router.navigate([
        '/customer/login'
      ]);

      return;
    }

    this.loadOrders();
  }

  loadOrders(): void {
    this.loading = true;
    this.error = '';

    this.api
      .get<any>('/customer/orders')
      .subscribe({
        next: response => {
          this.orders =
            Array.isArray(response)
              ? response
              : response?.orders || [];

          this.loading = false;
        },

        error: err => {
          this.loading = false;

          this.error =
            err?.error?.message ||
            'Erro ao carregar pedidos.';

          if (err?.status === 401) {
            this.logout();
          }
        }
      });
  }

goToMenu(): void {

  /*
   * Primeiro tenta voltar exatamente
   * para o cardápio de onde o cliente veio.
   */
  const storedMenuUrl =
    sessionStorage.getItem(
      'customer_return_url'
    );

  if (storedMenuUrl) {

    this.router.navigateByUrl(
      storedMenuUrl
    );

    return;
  }


  /*
   * Se não houver URL salva,
   * tenta descobrir pelo último pedido.
   */
  const restaurantSlug =
    this.orders?.[0]
      ?.restaurant
      ?.slug
      ?.trim();


  if (restaurantSlug) {

    this.router.navigate([
      '/cardapio',
      restaurantSlug
    ]);

    return;
  }


  /*
   * Não manda mais para Home.
   * Se não souber qual restaurante é,
   * permanece na tela.
   */
  console.warn(
    'Não foi possível identificar o cardápio do restaurante.'
  );
}

goToRestaurantMenu(order: any): void {

  const restaurantSlug =
    order?.restaurant
      ?.slug
      ?.trim();


  if (restaurantSlug) {

    this.router.navigate([
      '/cardapio',
      restaurantSlug
    ]);

    return;
  }


  /*
   * Caso o backend não tenha retornado
   * o slug no pedido, tenta usar
   * o cardápio salvo.
   */
  const storedMenuUrl =
    sessionStorage.getItem(
      'customer_return_url'
    );


  if (storedMenuUrl) {

    this.router.navigateByUrl(
      storedMenuUrl
    );

    return;
  }


  console.warn(
    'Não foi possível identificar o restaurante deste pedido.'
  );
}

  trackOrder(order: any): void {
    const trackingCode =
      order?.trackingCode;

    if (!trackingCode) {
      return;
    }

    this.router.navigate(
      ['/pedido', trackingCode],
      {
        state: {
          restaurantSlug:
            order?.restaurant?.slug
        }
      }
    );
  }

  getStatusLabel(status: string): string {
    const labels: Record<string, string> = {
      PENDING: 'Pendente',
      ACCEPTED: 'Aceito',
      PREPARING: 'Em preparo',
      READY: 'Pronto',
      OUT_FOR_DELIVERY: 'Saiu para entrega',
      DELIVERED: 'Entregue',
      CANCELED: 'Cancelado'
    };

    return labels[status] || status;
  }

  getStatusClass(status: string): string {
    const classes: Record<string, string> = {
      PENDING: 'status-pending',
      ACCEPTED: 'status-accepted',
      PREPARING: 'status-preparing',
      READY: 'status-ready',
      OUT_FOR_DELIVERY:
        'status-out-for-delivery',
      DELIVERED: 'status-delivered',
      CANCELED: 'status-canceled'
    };

    return classes[status] || 'status-pending';
  }

  getDeliveryTypeLabel(
    deliveryType: string
  ): string {
    const labels: Record<string, string> = {
      DELIVERY: 'Entrega',
      PICKUP: 'Retirada',
      TABLE: 'Consumo no local'
    };

    return (
      labels[deliveryType] ||
      deliveryType ||
      'Não informado'
    );
  }







repeatOrder(order: any): void {
  const restaurantSlug =
    order?.restaurant?.slug?.trim();

  if (!restaurantSlug) {
    alert(
      'Não foi possível identificar o restaurante deste pedido.'
    );
    return;
  }

  if (!order?.items?.length) {
    alert(
      'Este pedido não possui itens para repetir.'
    );
    return;
  }

  /*
   * Limpa a sacola atual para evitar misturar
   * produtos de restaurantes ou pedidos diferentes.
   */
  this.cart.clear();

  let addedItems = 0;

  order.items.forEach((item: any) => {
    if (!item?.product?.id) {
      return;
    }

    const quantity =
      Number(item.quantity) || 1;

    /*
     * O carrinho calcula o valor usando product.price.
     * Caso o backend não retorne price, utilizamos unitPrice.
     */
    const productForCart = {
      ...item.product,
      price: Number(
        item.product?.price ??
        item.unitPrice ??
        0
      )
    };

    this.cart.setItemQuantity(
      productForCart,
      quantity,
      item.notes?.trim() || ''
    );

    addedItems++;
  });

  if (!addedItems) {
    alert(
      'Nenhum produto válido foi encontrado neste pedido.'
    );
    return;
  }

  this.router.navigate(
    ['/cardapio', restaurantSlug],
    {
      state: {
        openCart: true,
        repeatedOrder: true
      }
    }
  );
}






  

  getCustomerInitial(): string {
    const name =
      this.customer?.name?.trim();

    return name
      ? name.charAt(0).toUpperCase()
      : 'C';
  }

  logout(): void {
    localStorage.removeItem(
      'customer_token'
    );

    localStorage.removeItem(
      'customer_user'
    );

    this.router.navigate([
      '/customer/login'
    ]);
  }

  private getStoredCustomer(): any {
    const storedCustomer =
      localStorage.getItem(
        'customer_user'
      );

    if (!storedCustomer) {
      return null;
    }

    try {
      return JSON.parse(storedCustomer);
    } catch {
      localStorage.removeItem(
        'customer_user'
      );

      return null;
    }
  }
}

